<template>
    <div class="video-content" :style="customStyle" @touchend="trackSelect" @touchmove="isScrolled = true">
        <div id="nio-player" style="width: 100%;height: 100%;" />
    </div>
</template>
<script>
import trackExposeMixin from '../mixin/track-expose';

export default {
    name: 'marketing-video',
    componentName: 'marketingVideo',
    mixins: [trackExposeMixin],
    data() {
        return {
            player: null,
            pauseObserver: null,
            isScrolled: false
        };
    },
    props: {
        customStyle: {
            type: String,
            default: 'margin-top: 0; margin-bottom:0'
        },
        src: String,
        poster: String,
        autoplay: {
            type: Boolean,
            default: true
        },
        trackSelectAction: Function
    },
    mounted() {
        this.initPlayer();
        this.initPauseObserver();
    },
    beforeDestroy() {
        if (this.pauseObserver) {
            this.pauseObserver.unobserve(this.$el);
        }
        if (this.player) {
            this.player.dispose();
        }
    },
    methods: {
        trackSelect() {
            if (this.isScrolled) {
                // 滚动or拖动行为
                this.isScrolled = false;
                return;
            }
            if (this.trackSelectAction) {
                this.trackSelectAction();
            }
        },
        initPlayer() {
            if (!this.src) {
                return;
            }
            import(`@nio-fe/nioplayer`).then(i => {
                const NIOPlayer = i.default;
                this.player = new NIOPlayer({
                    source: this.src,
                    poster: this.poster,
                    wasmURL: NIOPlayer.WASM_URL.PROD, // 可选择：DEV / TEST / STG / PROD
                    container: document.getElementById('nio-player'),
                    objectFit: 'contain',
                    controls: true,
                    autoplay: this.autoplay,
                    playsinline: true,
                    loop: false,
                    useNative: false
                });

                this.player.on('error', error => {
                    console.log(error);
                });
            });
        },
        initPauseObserver() {
            this.pauseObserver = new IntersectionObserver(
                this.pauseObserverCallBack,
                {
                    rootMargin: '0px',
                    threshold: 0
                }
            );
            this.pauseObserver.observe(this.$el);
        },
        pauseVideo() {
            this.player.pause();
        },
        pauseObserverCallBack(val) {
            if (val[0] && !val[0].isIntersecting) {
                this.pauseVideo();
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '~src/assets/css/variable.less';

.video-content {
    width: 375 * @layout375;
    height: 375 / 16 * 9 * @layout375;
    position: relative;
    z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/video.vue